import { EnvelopeIcon } from '@heroicons/react/24/solid';
import { ShareIcon } from '@heroicons/react/24/solid';
import { twMerge } from 'tailwind-merge';

import { Button } from './Button';
import { FacebookIcon } from './icons/FacebookIcon';
import { WhatsAppIcon } from './icons/WhatsAppIcon';

type Size = 'large' | 'medium' | 'small';
type Social = 'email' | 'facebook' | 'share' | 'whatsapp';

interface SocialButtonProps {
  href?: string;
  size?: Size;
  social?: Social;
}

const Sizes: Record<Size, string> = {
  small: 'p-1.5 text-sm',
  medium: 'p-2 text-lg',
  large: 'p-3 text-xl',
};

const Socials: Record<Social, string> = {
  whatsapp: 'bg-whatsapp hover:bg-whatsapp/[0.8]',
  facebook: 'bg-facebook hover:bg-facebook/[0.8]',
  email: 'bg-blue hover:bg-email/[0.8]',
  share: 'bg-primary-600 hover:bg-primary-700',
};

const icon = {
  whatsapp: WhatsAppIcon,
  facebook: FacebookIcon,
  email: EnvelopeIcon,
  share: ShareIcon,
};

export function SocialButton({
  size = 'small',
  social = 'share',
  href,
  ...props
}: SocialButtonProps): React.ReactElement {
  const defaultClasses = 'rounded-full border-0';
  const classNames = social
    ? twMerge(defaultClasses, Sizes[size], Socials[social])
    : defaultClasses;

  const SocialIcon = icon[social];

  return (
    <Button {...props} as="a" href={href} target="_blank" rel="noopener" className={classNames}>
      <SocialIcon className="h-5 w-5" />
    </Button>
  );
}
